'use strict'

import * as XLSX from 'xlsx'
import * as dot from 'dot-object'

import errorService from '@/services/errorService'

async function creaExcelFromSource(source, nomeFile, separatore) {
  try {
    const response = await fetch(source)
    const dati = await response.json()
    const dotted = []
    for (let d of dati) {
      var tgt = dot.dot(d);
      dotted.push(tgt)
    }
    // let ws = XLSX.utils.json_to_sheet(dotted, { skipHeader: true })
    // TODO: Capire se c'è qualche procedura che non vuole gli header di colonna. Per adesso (### 14.06.2024) rimessi per export dati su report
    let ws = XLSX.utils.json_to_sheet(dotted)
    var wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'Valori')
    XLSX.writeFile(wb, nomeFile, { FS: separatore || ';', strip: true })    
    // return sheet
  } catch (error) {
    console.log('error creaExcelFromSource', error)
    errorService.onError(error, 'creaExcelFromSource')
    return ''
  }
}

async function creaExcelData(dati, nomeFile, separatore, skipHeader = true) {
  try {
    const dotted = []
    for (let d of dati) {
      var tgt = dot.dot(d);
      dotted.push(tgt)
    }
    var ws = XLSX.utils.json_to_sheet(dotted, { skipHeader: skipHeader });
    var wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Valori');
    XLSX.writeFile(wb, nomeFile, { FS: separatore || ';', strip: true });
  } catch (error) {
    console.log('error creaExcelData', error)
    errorService.onError(error, 'creaExcelData')
    return ''
  }
}

async function creaExcelFromArray(dati, nomeFile, separatore) {
  try {
    var ws = XLSX.utils.json_to_sheet(dati, { skipHeader: true });
    var wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Valori');
    XLSX.writeFile(wb, nomeFile, { FS: separatore || ';', raw: true, strip: true });
  } catch (error) {
    console.log('error creaExcelData', error)
    errorService.onError(error, 'creaExcelData')
    return ''
  }
}

async function creaExcelFromArrayToMemory(dati, separatore) {
  try {
    var ws = XLSX.utils.json_to_sheet(dati, { skipHeader: true });
    var wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Valori');
    var data = XLSX.write(wb, { bookType: 'csv', type: 'string', sheet: 'Valori', FS: separatore || ';', raw: true, strip: true });
    return data
  } catch (error) {
    console.log('error creaExcelFromArrayToMemory', error)
    errorService.onError(error, 'creaExcelFromArrayToMemory')
    return ''
  }
}

/* intestazioniColonneModello(dati) {
  if (!dati || dati.length === 0) {
    return []
  }
  const riga = dati[0]
  const keys = Object.keys(riga)
  const mdColonne = this.modelloItem.colonne || []
  let k = 0
  const colonne = keys.map(x => {
    const s = x.split('.')
    return { key: x, value: (mdColonne[k++].label || s[s.length - 1]).toUpperCase() }
  })
  return colonne
}
 */

export default {
  creaExcelFromSource,
  creaExcelData,
  creaExcelFromArray,
  creaExcelFromArrayToMemory
}
